import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  userAwards: "",
};

const userAwardsSlice = createSlice({
  name: "userAwards",

  initialState: { awards: [] },
  reducers: {
    setUserAwards: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.awards = payload;
    },
  },
});

export const { setUserAwards } = userAwardsSlice.actions;

export default userAwardsSlice.reducer;
